import { useState, useEffect } from "react";
import { getInitialScreenType, getScreenType } from "../utils/screen";

export { getScreenType };

function useScreen() {
  const [screen, setScreen] = useState(getInitialScreenType);

  useEffect(() => {
    const handleResize = () => setScreen(getScreenType(window.innerWidth));

    // Initial call
    handleResize();

    // Event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean-up
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return screen;
}

export default useScreen;
